export const shortenAddress = (value: string, edge = 5): string =>
  value.length > edge * 2 + 3 ? `${value.slice(0, edge + 2)}…${value.slice(-edge)}` : value;

export const formatToken = (value: string, symbol = 'BTCB'): string => {
  const [whole = '0', fraction = ''] = value.split('.');
  const trimmed = fraction.slice(0, 8).replace(/0+$/, '');
  return `${whole}${trimmed ? `.${trimmed}` : ''} ${symbol}`;
};

export const formatUsd = (value: number): string =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: value >= 1_000 ? 0 : 2,
  }).format(value);

export const formatCompact = (value: number): string =>
  new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 }).format(value);

export const formatDate = (iso: string): string =>
  new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(iso));

export const isMemberId = (value: string): boolean => /^BD-[1-9]\d{0,8}$/i.test(value.trim());

export const buildReferralUrl = (memberId: string, appOrigin: string): string => {
  if (!isMemberId(memberId)) throw new TypeError('A valid B-Dynamic ID is required');
  const url = new URL('/join', appOrigin);
  url.searchParams.set('ref', memberId.toUpperCase());
  return url.toString();
};

export const buildWhatsAppShareUrl = (memberId: string, registrationUrl: string): string => {
  if (!isMemberId(memberId)) throw new TypeError('A valid B-Dynamic ID is required');
  const url = new URL('https://wa.me/');
  url.searchParams.set('text', `Join B-Dynamic with my sponsor ID ${memberId.toUpperCase()}.\n${registrationUrl}`);
  return url.toString();
};

export const copyText = async (value: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch {
    return false;
  }
};
